import React from 'react';
import moment from 'moment';

import {
    Tabs
} from 'antd';

import {
    _getProductChanges
} from '../../services'

import ProductLogs from './product-logs'
import PriceFlag from './price-flags'

const { TabPane } = Tabs;

class ProductChanges extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        return(
            <Tabs defaultActiveKey="1">
                <TabPane tab="Logs" key="1">
                    <ProductLogs />
                </TabPane>
                <TabPane tab="Price Flags" key="2">
                    <PriceFlag />
                </TabPane>
            </Tabs>
        )
    }
}

export default ProductChanges


// WEBPACK FOOTER //
// ./src/components/product/product-changes.js